module.exports = __webpack_public_path__ + "img/servicios3.76ca7aec.png";